import { makeStyles } from "@material-ui/core";
import FLHeightControlPanel from "./FLHeightControlPanel";
import ZoomControlPanel from "./ZoomControlPanel";

const useStyles = makeStyles(() => ({
  panel: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
    width: 175,
    top: 3,
    right: 50
  }
}))

function CsControlPanel() {
  const classes = useStyles();

  return (
    <div className={classes.panel}>
      <FLHeightControlPanel></FLHeightControlPanel>
      <ZoomControlPanel></ZoomControlPanel>
    </div>
  )
}

export default CsControlPanel;
